module.exports = __webpack_public_path__ + "1bf4162ac8bdedf83a375a81e3da771f.png";